var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oar-row",attrs:{"data-testid":"organization-area-row"}},[_c('span',{staticClass:"oar-title",attrs:{"data-testid":"oar-title"}},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"oar-description",attrs:{"data-testid":"oar-description"}},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }